export default function formatPhoneNumber(phoneNumberString: string): string {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, "");
  if (cleaned) {
    return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6, cleaned.length)}`;
  }

  return "";
}
